module.exports = __webpack_public_path__ + "static/media/icono-rebozador-compradores-uy.149f2201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-rebozador-compradores-uy.png
// module id = 304
// module chunks = 0